import { Bishop, King, Knight, Pawn, Queen, Rook } from './Default';
import * as stroked from './Stroked';
import { ChessPieces } from './types';

export const DefaultChessPieces: ChessPieces = {
  K: King,
  Q: Queen,
  R: Rook,
  B: Bishop,
  N: Knight,
  P: Pawn,
};

export const StrokedChessPieces: ChessPieces = {
  K: stroked.King,
  Q: stroked.Queen,
  R: stroked.Rook,
  B: stroked.Bishop,
  N: stroked.Knight,
  P: stroked.Pawn,
};
